import AlertIconFilled from "../../../assets/images/generico/AlertIconFilled";

const InformacionBuscador = ({onClick,leyendaCircuito}) => {
  return (
    <div className="ptur-buscador-leyendaCirc-estudio pointer">
      <button
        className="ptur-buscador-infoBuscadorBtn-estudio"
        onClick={onClick}
      >
        <AlertIconFilled color={"var(--color-primary"} />
        <span className="ptur-buscador-infoBuscadorTxt-estudio c-primary rb14m">
          Podés seguir agregando mas estudios {leyendaCircuito === "RMN" ? "de resonancia" : leyendaCircuito === "TOMO" ? "de tomografía" : "relacionados"}
        </span>
      </button>
    </div>
  );
};

export default InformacionBuscador;
